import { makeStyles } from "@mui/styles";

const dynamicStyle = makeStyles((them) => ({
  qrCodeGrid: {
    textAlign: "center",
    marginTop: "160px",
  },
  downloadGrid: {
    textAlign: "center",
    marginTop: "30px",
  },
}));

export default dynamicStyle;
